import { render, staticRenderFns } from "./platform-categories.vue?vue&type=template&id=426e0279"
import script from "./platform-categories.vue?vue&type=script&lang=js"
export * from "./platform-categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports